module.exports = __webpack_public_path__ + "static/media/15c.19e68b62.ogg";